// extracted by mini-css-extract-plugin
export default {"container":"RevenuesCard_container__zHIxq","month":"RevenuesCard_month__ReSfZ","label":"RevenuesCard_label__0lY2r","value":"RevenuesCard_value__b7bOC"};